import React from 'react';
import { string, shape, arrayOf } from 'prop-types';

export const ResponsivePicture = ({
    className,
    picture = [],
    src = '',
    alt = ''
}) => (
    <picture className={className}>
        {picture.map((image, index) => (
            <source key={index} media={image.media} srcSet={image.srcSet}/>
        ))}
        <img src={src}
            loading="lazy"
            alt={alt}/>
    </picture>
);

ResponsivePicture.propTypes = {
    className: string,
    picture: arrayOf(shape({
        media: string,
        srcSet: string
    })),
    alt: string.isRequired,
    src: string.isRequired
};
